import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import ThesaurusItemFolderInfo from '../ThesaurusItemFolderInfo';
import ThesaurusItemCheckboxInfo from '../ThesaurusItemCheckboxInfo';

export default function ThesaurusItemInfo(props) {
  const { isFolder } = props;

  if (isFolder) {
    return <ThesaurusItemFolderInfo {...props} />;
  }

  return <ThesaurusItemCheckboxInfo {...props} />;
}

ThesaurusItemInfo.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  isFolder: PropTypes.bool.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
  partiallySelected: PropTypes.bool.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};
